import React, { useEffect, useState } from 'react';
import { useStateValue } from '../../../services/ContextProvider';
import { getSubscribers } from '../../../services/DashboardService';
import './Subscribers.scss';
import { TiNews } from 'react-icons/ti';
import { BsPeopleFill } from 'react-icons/bs';

const Subscribers = () => {

    const [subscribers, setSubscribers] = useState([]);
    const { subslistState, subslistDispatch } = useStateValue();
    useEffect(async () => {
        if (subslistState.subList.length === 0) {
            await getSubscribers(subslistDispatch, subslistState.subList);
        }
    }, [subslistState]);

    useEffect(() => {
        setSubscribers(subslistState.subList);
    }, [subslistState]);


    return (
        <div>
            <div class="m-4" >
                <h4 class="display-4 contactus-title"><TiNews/> &nbsp;&nbsp; <b>NewsLetter Subscribers</b>
                    <span class="badge badge-secondary"></span></h4>
                <button type="button" class="btn btn-primary"><BsPeopleFill/>&nbsp;
                Total Subscribers&nbsp; <span class="badge badge-light rounded-circle count-circle">{ subscribers.length}</span>
                </button>
            </div>
            <hr />
            {
                subscribers.map((subcriber, index) => {
                    return (
                        <div className="col-md-8" key={index}>
                            <ul className="list-group ">
                                <li class="list-group-item list-group-item-action"><span className="mx-2">{index+1}</span>.&nbsp;&nbsp;&nbsp;{subcriber.email}</li>
                            </ul>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default Subscribers;
